import React from "react"
import Select, { GetOptionLabel, GetOptionValue } from "react-select"

export type Option = any

export interface SelectProps {
  options: Option[]
  value?: Option | null
  onChange?: (value: Option | null) => void
  defaultValue?: Option
  className?: string
  styles?: any
  isDisabled?: boolean
  required?: boolean
  getOptionLabel?: GetOptionLabel<any>
  getOptionValue?: GetOptionValue<any>
  isSearchable?: boolean
  placeholder?: string
  menuPortalTarget?: HTMLElement | null
}

// Must beat .modal's z-index (10105 — see _header.scss) or a portaled menu
// opened inside any modal renders invisibly behind the modal's own content.
const defaultMenuPortalStyles = {
  menuPortal: (base: any) => ({ ...base, zIndex: 10110 }),
  menu: (base: any) => ({ ...base, zIndex: 10110 }),
}

const CommonSelect: React.FC<SelectProps> = ({
  options,
  value,
  onChange,
  className,
  styles,
  getOptionLabel,
  getOptionValue,
  isDisabled,
  isSearchable = true,
  placeholder = "select",
  // Default to portaling into <body> so the open menu can never be clipped
  // or rendered behind a later sibling (table header, sticky bar, etc.) by
  // an ancestor's overflow/stacking context. Pass `null` explicitly to opt
  // out (e.g. inside a modal that already manages its own stacking).
  menuPortalTarget = typeof document !== "undefined" ? document.body : undefined,
}) => {
  const mergedStyles =
    menuPortalTarget && typeof styles === "object"
      ? { ...defaultMenuPortalStyles, ...styles }
      : menuPortalTarget
        ? defaultMenuPortalStyles
        : styles

  return (
    <Select
      classNamePrefix="react-select"
      className={className}
      options={options}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      getOptionLabel={getOptionLabel}
      getOptionValue={getOptionValue}
      isDisabled={isDisabled}
      isSearchable={isSearchable}
      menuPortalTarget={menuPortalTarget}
      styles={mergedStyles}
    />
  )
}

export default CommonSelect
